__turbopack_context__.v({
  "body": "style-module-scss-module__sD78MW__body",
  "container": "style-module-scss-module__sD78MW__container",
});
